import React, { useId } from "react";

export default function TeamActivitySection({ data }) {
  const titleId = useId();

  if (!data?.items?.length) return null;

  return (
    <section className="dynamic-team-activity-section" aria-labelledby={titleId}>
      <div className="container">
        <div className="dynamic-team-activity-heading text-center">
          <span className="main-title">{data.eyebrow}</span>
          <h2 className="heading" id={titleId}>{data.title}<br />{data.titleSecondLine}</h2>
        </div>
        <div className="row dynamic-team-activity-grid">
          {data.items.map((item) => (
            <div className="col-lg-3 col-md-6" key={item.title}>
              <article className="dynamic-team-activity-card">
                <img src={item.image} alt={item.imageAlt} width="378" height="520" loading="lazy" />
                <div className="dynamic-team-activity-content">
                  <div className="dynamic-team-activity">
                    <h3>{item.title}</h3>
                    <div className="dynamic-team-activity-details">
                      <div><p>{item.description}</p></div>
                    </div>
                  </div>
                  <a className="dynamic-team-activity-action" href={item.buttonLink || data.buttonLink} aria-label={`Enquire about ${item.title}`}>
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </a>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
